import { useMutation } from '@apollo/client'
import React from 'react'
import { Trans, t } from '@lingui/macro'

import { Text, ButtonLight, Flex } from 'front-end/src/components'

import Message, { MessageTypes } from '../../components/common/message/Message'
import { notification } from '../../components/common/notifications/Notifications'
import { apolloClientPublic } from '../../graphql/apolloClient'
import sendVerificationEmailMutation, {
  ISendVerificationEmailResponse,
  ISendVerificationEmailVariables
} from './operations/public/sendVerificationEmailMutation'
import { UserProfilePageDetailAsMeFragment } from './UserProfilePage.codegen'

export const UserVerification = ({
  user
}: {
  user: UserProfilePageDetailAsMeFragment
}) => {
  const [sendVerificationEmail, { loading: sendVerificationEmailLoading }] =
    useMutation<
      ISendVerificationEmailResponse,
      ISendVerificationEmailVariables
    >(sendVerificationEmailMutation, {
      client: apolloClientPublic
    })

  if (!user.email) {
    return null
  }

  return (
    <Message type={MessageTypes.WARNING}>
      <Flex alignItems="center">
        <Text mx="8px" minW="140px">
          <Trans>Your email address has not been verified</Trans>
        </Text>

        <>
          <Text m="8px" display={['none', 'inline']} fontSize="12px">
            <Trans>
              To verify your email address, please click on the verify link in
              the email we have sent. If you have not yet received the
              verification email click the button below to re-send it.
            </Trans>
          </Text>

          <ButtonLight
            m="4px"
            maxW={['120px', null]}
            minW={[null, '200px']}
            disabled={sendVerificationEmailLoading}
            isLoading={sendVerificationEmailLoading}
            onClick={async () => {
              const { data } = await sendVerificationEmail({
                variables: {
                  email: user.email as string,
                  organisationId: user.organisation_id as number
                }
              })
              if (data) {
                const { type, message } = data.sendVerificationEmail
                if (type && message) {
                  notification[type](message)
                } else {
                  notification.error(t`Unable to resend verification email`)
                }
              }
            }}
          >
            <Text display={['none', 'inline']}>
              <Trans>Resend verification email</Trans>
            </Text>
            <Text display={['inline', 'none']}>
              <Trans>Resend</Trans>
            </Text>
          </ButtonLight>
        </>
      </Flex>
    </Message>
  )
}
